import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-42968065"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "account-cancellation"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top-notify"
}, " 尊敬的用户您好，因为阳光保险 app 使用阳光保险集团统一认证账户服务平台，由该平台为您登录阳光保险集团各互联网平台（阳光车生活、我家阳光app 等）提供统一认证服务，基于此，请您确认本次注销： ", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cancellation-title import-title"
}, "注销须知", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cancellation-content"
}, [/*#__PURE__*/_createElementVNode("p", null, " 1、无法使用本账户登录、授权登录或跳转到第三方及使用服务（保险服务、理赔服务）。 "), /*#__PURE__*/_createElementVNode("p", null, " 2、无法查看账户下的个人资料和历史信息（包括但不限于用户名、头像、订单信息、保单信息以及相关服务的使用记录等）。 "), /*#__PURE__*/_createElementVNode("p", null, " 3、基于本账号下的订单及交易记录、账号内的搜索记录 或其他记录，前述信息及资料将被清除且无法恢复。 "), /*#__PURE__*/_createElementVNode("p", null, " 4、基于账号所获得的卡券、经验值、阳光币以及阳光保险发放的其他权益均视为您自行放弃且无法恢复使用。 ")], -1));
const _hoisted_5 = {
  class: "cancellation-type"
};
const _hoisted_6 = {
  class: "cancellation-actions"
};
import MainButton from '@/components/MainButton/MainButton.vue';
import { ref, getCurrentInstance, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { cancelAccountApi } from '@/api/commonApi';
import { fullScreen, loginOut, closeWebview } from '@/utils/navitiveApi/common';
export default /*#__PURE__*/_defineComponent({
  __name: 'AccountCancellation',
  setup(__props) {
    var _getCurrentInstance$p, _getCurrentInstance;
    const {
      $alert,
      $loading
    } = (_getCurrentInstance$p = (_getCurrentInstance = getCurrentInstance()) === null || _getCurrentInstance === void 0 ? void 0 : _getCurrentInstance.proxy) !== null && _getCurrentInstance$p !== void 0 ? _getCurrentInstance$p : {};
    const router = useRouter();
    const cancellationMode = ref('');
    const countDownFinished = ref(false);
    const onCountDownfinish = () => {
      countDownFinished.value = true;
    };
    const onCancellation = async () => {
      if (!cancellationMode.value) {
        $alert({
          message: '请选择注销方式'
        });
        return;
      }
      $loading.openLoading();
      try {
        const {
          code,
          message,
          data
        } = await cancelAccountApi({
          type: cancellationMode.value
        });
        $loading.closeLoading();
        $alert({
          message: code === 9000 ? '注销成功' : message
        }).then(() => {
          closeWebview();
          loginOut();
        });
      } catch (error) {
        console.error(error);
      }
    };
    onMounted(() => {
      fullScreen();
    });
    return (_ctx, _cache) => {
      const _component_NavBar = _resolveComponent("NavBar");
      const _component_van_radio = _resolveComponent("van-radio");
      const _component_van_radio_group = _resolveComponent("van-radio-group");
      const _component_van_count_down = _resolveComponent("van-count-down");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_NavBar, {
        title: "注销账号",
        "back-to-close": ""
      }), _hoisted_2, _hoisted_3, _hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_van_radio_group, {
        modelValue: cancellationMode.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => cancellationMode.value = $event)
      }, {
        default: _withCtx(() => [_createVNode(_component_van_radio, {
          name: "S",
          "checked-color": "#F5831C",
          "icon-size": "16px"
        }, {
          default: _withCtx(() => [_createTextVNode(" 注销【阳光保险 App】平台账户，您可以继续使用和保留统一认证账户及阳光保险集团各互联网平台（我家阳光、阳光车生活等）的账户。 ")]),
          _: 1
        }), _createVNode(_component_van_radio, {
          name: "A",
          "checked-color": "#F5831C",
          "icon-size": "16px"
        }, {
          default: _withCtx(() => [_createTextVNode(" 注销【阳光保险 App】账户的同时，同步注销统一认证账户以及本人在阳光保险集团各互联网平台（我家阳光、阳光车生活等）的账户。 ")]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_6, [_createVNode(MainButton, {
        size: "small",
        disabled: !countDownFinished.value,
        onClick: onCancellation
      }, {
        default: _withCtx(() => [_createTextVNode(" 我已清楚以上风险 "), _withDirectives(_createVNode(_component_van_count_down, {
          class: "cancellation-count-down",
          millisecond: "",
          time: 4 * 1000,
          format: "(ss s)",
          onFinish: onCountDownfinish
        }, null, 512), [[_vShow, !countDownFinished.value]])]),
        _: 1
      }, 8, ["disabled"]), _createVNode(MainButton, {
        size: "small",
        onClick: _unref(closeWebview)
      }, {
        default: _withCtx(() => [_createTextVNode("再想想")]),
        _: 1
      }, 8, ["onClick"])])]);
    };
  }
});